"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Choice = _interopRequireDefault(require("./Choice"));

var _TextAnswer = _interopRequireDefault(require("./TextAnswer"));

var _NumericAnswer = _interopRequireDefault(require("./NumericAnswer"));

var _FileUpload = _interopRequireDefault(require("./FileUpload"));

var _Rating = _interopRequireDefault(require("./Rating"));

var _Select = _interopRequireDefault(require("./Select"));

var _constants = require("../utils/constants");

var _AddressChecker = _interopRequireDefault(require("./AddressChecker"));

var _Message = _interopRequireDefault(require("./Message"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getQuestionComponent = function getQuestionComponent(id, component, disabled, value, setValue, error) {
  switch (component.type) {
    case _constants.CHOICE_TYPE:
      return /*#__PURE__*/_react.default.createElement(_Choice.default, _extends({
        questionId: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.TEXT_ANSWER_TYPE:
      return /*#__PURE__*/_react.default.createElement(_TextAnswer.default, _extends({
        id: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.FILE_UPLOAD_TYPE:
      return /*#__PURE__*/_react.default.createElement(_FileUpload.default, _extends({
        id: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.RATING_TYPE:
      return /*#__PURE__*/_react.default.createElement(_Rating.default, _extends({
        id: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.ADDRESS_CHECKER_TYPE:
      return /*#__PURE__*/_react.default.createElement(_AddressChecker.default, {
        id: id,
        setValue: setValue
      });

    case _constants.SELECT_TYPE:
      return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
        questionId: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.NUMERIC_ANSWER_TYPE:
      return /*#__PURE__*/_react.default.createElement(_NumericAnswer.default, _extends({
        id: id
      }, component.props, {
        disabled: disabled,
        value: value,
        setValue: setValue,
        error: error
      }));

    case _constants.MESSAGE:
      return /*#__PURE__*/_react.default.createElement(_Message.default, _extends({
        id: id
      }, component.props));

    default:
      break;
  }
};

var QuestionComponent = function QuestionComponent(_ref) {
  var question = _ref.question,
      disabled = _ref.disabled,
      value = _ref.value,
      setValue = _ref.setValue,
      error = _ref.error;
  return getQuestionComponent(question.id, question.component, disabled, value, setValue, error);
};

QuestionComponent.propTypes = {
  /** Object containing the question information */
  question: _propTypes.default.PropTypes.shape({
    /** The unique identifier of the question */
    id: _propTypes.default.string,

    /** The position of the question in the survey */
    position: _propTypes.default.number,

    /** The title of the question */
    title: _propTypes.default.string,

    /** The supporting description of the question */
    description: _propTypes.default.string,

    /** The conditions a question has to be displayed */
    conditions: _propTypes.default.array,

    /** Information on the component to be rendered for the question */
    component: _propTypes.default.shape({
      /** The type of component the question should render */
      type: _propTypes.default.string,

      /** The props to be passed to the rendered question component */
      props: _propTypes.default.object
    })
  }).isRequired,

  /** Indicates whether the question component should be disabled */
  disabled: _propTypes.default.bool,

  /** The response value for this question component */
  value: _propTypes.default.any,

  /** Function to set the response value for this question component */
  setValue: _propTypes.default.func,

  /** Indicates whether there is an error with the current value of the question */
  error: _propTypes.default.bool
};
QuestionComponent.defaultProps = {
  disabled: false,
  value: null,
  setValue: function setValue() {}
};
var _default = QuestionComponent;
exports.default = _default;